import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    client: null,
    pageBackground: {},
    pageTitle: null,
    pageSubTitle: null,
    logo: {},
    boxedLogo: {},
    clientName: null,
    favicon: null,
    partners: [],
    visuals: [],
    lostPassword: {},
    loginPage: {},
    homePage: {},
    intro: {},
    basicStatBloc: null,
    techStatBloc: null,
    helpUrl: null,
    showDuration: false,
  }),
  getters: {
    uiClient() {
      return this.client
    },
    uiPageBackground() {
      return this.pageBackground
    },
    uiLogo() {
      return this.logo
    },
    uiBoxedLogo() {
      return this.boxedLogo
    },
    uiClientName() {
      return this.clientName
    },
    uiFavicon() {
      return this.favicon
    },
    uiPartners() {
      return this.partners
    },
    uiVisuals() {
      return this.visuals
    },
    uiLostPassword() {
      return this.lostPassword
    },
    uiLoginPage() {
      return this.loginPage
    },
    uiHomePage() {
      return this.homePage
    },
    uiIntro() {
      return this.intro
    },
    uiPageTitle() {
      return this.pageTitle
    },
    uiPageSubTitle() {
      return this.pageSubTitle
    },
    uiHelpUrl() {
      return this.helpUrl
    },
    uiShowDuration() {
      return this.showDuration
    },
  },
  actions: {
    reset() {
      this.client = null
      this.pageBackground = {}
      this.pageTitle = null
      this.pageSubTitle = null
      this.logo = {}
      this.boxedLogo = {}
      this.clientName = null
      this.favicon = null
      this.partners = []
      this.visuals = []
      this.lostPassword = {}
      this.loginPage = {}
      this.homePage = {}
      this.intro = {}
      this.basicStatBloc = {}
      this.techStatBloc = {}
      this.showDuration = false
    },
    setClient(val) {
      this.client = val
    },
    setPageBackground(val) {
      this.pageBackground = val
    },
    setLogo(val) {
      this.logo = val
    },
    setBoxedLogo(val) {
      this.boxedLogo = val
    },
    setClientName(val) {
      this.clientName = val
    },
    setFavicon(val) {
      this.favicon = val
      if (val) {
        let link = document.querySelector("link[rel~='icon']");

        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }

        link.href = val;
      }
    },
    setPartners(val) {
      this.partners = val
    },
    setVisuals(val) {
      this.visuals = val
    },
    setLostPassword(val) {
      this.lostPassword = val
    },
    setLoginPage(val) {
      this.loginPage = val
    },
    setHomePage(val) {
      this.homePage = val
    },
    setIntro(val) {
      this.intro = val
    },
    setPageTitle(val) {
      this.pageTitle = val
    },
    setPageSubTitle(val) {
      this.pageSubTitle = val
    },
    setBasicStatBloc(val) {
      this.basicStatBloc = val
    },
    setTechStatBloc(val) {
      this.techStatBloc = val
    },
    setHelpUrl(val) {
      this.helpUrl = val
    },
    setShowDuration(val) {
      this.showDuration = val
    },
  },
})
